import { QueryBuilder } from '@cxc/core/builders';
import { withCache } from '@ngneat/cashew';
import { Observable } from 'rxjs';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { environment } from '@environments/environment';

import { platformAPI } from '@services/API/endpoints';

@Injectable({
  providedIn: 'root',
})
export class FacilitiesService {
  private http = inject(HttpClient);

  public getFacilities(
    trustNumber: string,
    reportedAt: string,
    loaderOptIn: boolean | string = true
  ): Observable<any[]> {
    const query = new QueryBuilder();

    query.equals('reported_at', reportedAt);
    query.equals('show_cutoff_dates', 'false');
    query.equals('is_primary', 'true');

    return this.http.get<any[]>(
      platformAPI.trusts(trustNumber).lender.operations(query),
      {
        headers: new HttpHeaders({
          'Loader-Opt-In': `${loaderOptIn}`,
          'Auth-Opt-In': 'true',
        }),
        context: withCache({
          ttl: environment.CACHE_LIFETIME!,
        }),
      }
    );
  }
}
